import { Injectable } from "@angular/core";
import { Http, RequestOptionsArgs } from "@angular/http";
import { Location } from "@angular/common";
import { environment } from "../../environments/environment";
import { HttpErrorResponse } from "@angular/common/http";
import { AlertService } from "./alert.service";
import { DataService } from "./data.service";
import { Observable } from "rxjs/Observable";

@Injectable()
export class HttpWrapperService {
  private readonly backEndUrl: string;

  constructor(public http: Http) {
    this.backEndUrl = environment.BACKEND_API_URL;
  }

  public static ParamsObjectToCommaArrays(params: any): any {
    if (!params) {
      return "";
    }

    const transformedParams: Record<string, string> = {};

    for (const key in params) {
      if (!(params[key] && Array.isArray(params[key]))) {
        continue;
      }
      const arr = params[key];
      const isPrimitiveArray = params[key].every(
        (item) => typeof item === "string" || typeof item === "number"
      );
      if (arr.length > 0 && isPrimitiveArray) {
        transformedParams[key] = params[key].join(",");
      }
    }
    return { ...params, ...transformedParams };
  }
  public getExternalUrl(url, options?: RequestOptionsArgs) {
    return this.http.get(url, options);
  }

  public get(url, options?: RequestOptionsArgs) {
    return this.http.get(this.addBackendURL(url), options);
  }

  public post(url, body, options?) {
    return this.http.post(this.addBackendURL(url), body, options);
  }
  public delete(url, options?) {
    return this.http.delete(this.addBackendURL(url), options);
  }
  public put(url, body, options?) {
    return this.http.put(this.addBackendURL(url), body, options);
  }

  public patch(url, body, options?) {
    return this.http.patch(this.addBackendURL(url), body, options);
  }

  private addBackendURL(url: string) {
    return Location.joinWithSlash(this.backEndUrl, url);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/http.wrapper.service.ts